
import { ResolvedFn, RejectedFn, Interceptor } from '../types';

/**
 * 拦截器
 * https://doc.weixin.qq.com/flowchart/f3_AGoA1wY6ACo6tvhQc6jSruh0wHWy8?scode=AJEAIQdfAAobJNDUnTAGoA1wY6ACo
 */
export class InterceptorManager<T> {
  private interceptors: (Interceptor<T> | null)[];

  public constructor() {
    this.interceptors = [];
  }

  public use(resolved: ResolvedFn<T>, rejected: RejectedFn): number {
    this.interceptors.push({
      resolved,
      rejected,
    });
    return this.interceptors.length - 1;
  }

  public forEach(fn: (interceptor: Interceptor<T>) => void): void {
    this.interceptors.forEach((interceptor) => {
      if (interceptor !== null) {
        fn(interceptor);
      }
    });
  }

  public eject(id: number): void {
    if (this.interceptors[id]) {
      this.interceptors[id] = null;
    }
  }
}
